type ErrorOrMessage = Error | string

const coalesce = (arg: ErrorOrMessage) =>
    typeof arg === "string" ? new Error(arg) : arg

export function assert(
    expression: any,
    message: ErrorOrMessage = "AssertionError: expression == false"
): asserts expression {
    if (!expression) throw coalesce(message)
}

export function assertNotNull<T>(
    value: T,
    message: ErrorOrMessage = "AssertionError: value == null"
) {
  assert(value != null, message)
  return value
}
